import SolicitacaoEventoRealizados from './componentes/SolicitacaoEventoRealizados.vue';
import SolicitacaoEventoRealizadosLista from './componentes/SolicitacaoEventoRealizadosLista.vue';

export default {
  path: '/solicitacao-evento-realizados',
  component: SolicitacaoEventoRealizados,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoEventoRealizadosLista,
      name: 'solicitacao-evento-realizados',
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-evento-realizados/rotas.js